import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import http from "@/api";

/**
 * Phase2Gate — renderiza un mensaje informativo cuando una funcionalidad del
 * proveedor está deshabilitada por feature flag en Fase 1. Si la flag está ON,
 * renderiza el componente hijo normalmente.
 *
 * Filosofía Fase 1: el proveedor consulta, Lala alimenta. Cualquier feature de
 * captura/edición vive detrás de esta puerta.
 */
export default function Phase2Gate({ flag, title, children }) {
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    let mounted = true;
    http.get("/program/supplier-flags")
      .then((r) => { if (mounted) setEnabled(Boolean(r.data?.flags?.[flag])); })
      .catch(() => { if (mounted) setEnabled(false); });
    return () => { mounted = false; };
  }, [flag]);

  if (enabled === null) {
    return <div className="text-center py-20 font-hand text-2xl text-[var(--lala-blue)]">Cargando…</div>;
  }
  if (enabled) return children;

  return (
    <div className="px-6 py-16 max-w-2xl mx-auto" data-testid={`phase2-gate-${flag}`}>
      <div className="bg-white/80 rounded-2xl border-2 border-dashed border-[var(--lala-blue)]/30 p-10 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-[var(--lala-blue)]/10 flex items-center justify-center mb-4">
          <i className="fa-solid fa-route text-2xl text-[var(--lala-blue)]"></i>
        </div>
        <p className="font-hand text-[var(--lala-blue)] text-2xl mb-2">fase 2 · roadmap</p>
        <h1 className="text-3xl font-extrabold text-[var(--ink)] mb-4">{title || "Funcionalidad en Fase 2"}</h1>
        <p className="text-[var(--ink-soft)] leading-relaxed mb-6">
          En esta primera fase del programa <b>Lala Elite</b> alimenta y gobierna tu información
          directamente para asegurar consistencia y trazabilidad. Tú únicamente consultas tu desempeño.
        </p>
        <p className="text-sm text-[var(--ink-soft)] mb-8">
          Esta funcionalidad (autoevaluación, evidencia documental o evaluación 360°)
          se habilitará en la <b>Fase 2</b> del programa, una vez consolidado el modelo de gobierno con Lala.
        </p>
        <Link
          to="/mi-evaluacion"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[var(--lala-blue)] text-white font-semibold hover:bg-[var(--lala-blue-deep)]"
        >
          <i className="fa-solid fa-chart-line"></i> Ir a Mi desempeño
        </Link>
      </div>
    </div>
  );
}
